<div></div>
<script>
import {Doughnut, mixins} from "vue-chartjs"

const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ["data", "options", "title", "legend"],
  mounted () {
    this.renderPieChart()
  },

  methods: {
    updateChart: function () {
      this.$data._chart.update()
    },
    renderPieChart: function () {

      let gen = {
        borderWidth: "10px",
        hoverBorderWidth: "10px",
        title: {
          display: true,
          text: this.title
        },
        plugins: {
          labels: {
            render: 'value',
            precision: 1,
            fontColor: '#fff',
            overlap: false

          }
        },
        legend: {
          display: true,
          position: 'left',
          labels: {
            fontSize: 10

          }

        }

      }
      let opt = Object.assign({}, gen, this.options
      )
      this.renderChart(this.chartData, opt)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/PieChart.vue